// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-search"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9.5M15 6.5V9.5M9 17.5V3.5M9 17.5L10.5 18.375","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19.9036 18.8997L21.5 20.5M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-search')
export default class MapSearchIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-search',
    }
  }
}
